import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Cradlepoint } from '@app/shared/models/cradlepoint/cradlepoint.model';


@Component({
    selector: 'app-cradlepoint-card',
    templateUrl: './cradlepoint-card.component.html',
    styleUrls: ['./cradlepoint-card.component.css'],
    standalone: false
})
export class CradlepointCardComponent implements OnInit, OnDestroy {
    @Input() cradlepoint: Cradlepoint;

    constructor() {}

    ngOnInit() {}
    ngOnDestroy() {}


}